/* @flow */

import { List, Map } from 'immutable'
import { objectMap } from '../helpers/object'
import type { ValueSuccessType } from './index'
import type { ValidationType } from './index'

export type ValueMapType = Map<string, List<ValueSuccessType> | ValueSuccessType>
export type ValueListType = List<ValueMapType>
export type ValuesType = ValueListType | ValueMapType

export const foldValidations = (validator: (ValueSuccessType) => ValidationType, value: ValueSuccessType): ?string => {
  return validator(value).cata({
    Success: () => {
      return null
    },
    Failure: (message) => {
      return message
    }
  })
}

export const validate = (validator: (ValueSuccessType) => ValidationType, value: ValueSuccessType) => {
  return foldValidations(validator, value)
}

/**
 *
 * @param  {object} validations
 * @param  {Map} values
 * @param  {string} name
 * @return {Array}
 */
export const validationHelper = (validations: Object, values: ?ValueMapType) => (name: string) => {
  // $FlowFixMe
  const value = Map.isMap(values) || List.isList(values) ? (values.get(name): any) : null
  return List.isList(value) && !validations[name].arrayCheck // $FlowFixMe
    ? value.toJS().map((av) => validate(validations[name], av)) // $FlowFixMe
    : validate(validations[name], value)
}

/**
 * creates structure with that contains the errors
 * @param  {object} validations needed validations
 * @param  {Map}    values      data to test the validations agains
 * @return {object}
 */
export const validateObject = (validations: Object, values: ?ValuesType): Object | Array<Object> => {
  if (Object.keys(validations).length == 0) {
    return {}
  }
  if (List.isList(values)) {
    // $FlowFixMe
    return ((values: any): ValueListType).map((value) => validateObject(validations, value)).toArray()
  }
  const vh = validationHelper(validations, ((values: any): ?ValueMapType))
  // $FlowFixMe
  return objectMap((_, field) => {
    if (typeof validations[field] == 'object') {
      // $FlowFixMe: Flow does not know Map.isMap & List.isList
      const subValues: ?ValuesType = Map.isMap(values) || List.isList(values) ? (values.get(field): any) : null
      if (List.isList(subValues)) {
        return subValues // $FlowFixMe: Flow does not know List.isList
          .map((obj: any) => {
            return validateObject(validations[field], obj)
          })
          .toJS()
      } else {
        // $FlowFixMe
        return validateObject(validations[field], subValues)
      }
    } else {
      return vh(field)
    }
  }, validations)
}

/**
 * check if the object from the validation contains an error
 * @param {object} - Two level structure { company: { name: { value: '', hasError: true } }.
 * @returns {boolean}
 * @example
 * validationHasError({ company: { name: { value: '', hasError: true } }) == true
 */
export const validationHasError = (valid: Array<Object> | Object | string | boolean): boolean => {
  if (Array.isArray(valid)) {
    return valid.some(validationHasError)
  } else if (valid instanceof Object) {
    // $FlowFixMe fix type error here because Object.values returns Array<mixed>
    return Object.values(valid).some(validationHasError)
  } else {
    return valid === true || typeof valid == 'string'
  }
}
